import { render, staticRenderFns } from "./FerryAgency.vue?vue&type=template&id=c97b4030&"
import script from "./FerryAgency.vue?vue&type=script&lang=js&"
export * from "./FerryAgency.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports